import React, { useState } from 'react';

export default function FamilyMembers({ onFamilyChange, initialFamily = [] }) {
  const [familyMembers, setFamilyMembers] = useState(initialFamily);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newMember, setNewMember] = useState({ name: '', age: '', relationship: '' });

  const relationships = [
    'Hijo/Hija',
    'Cónyuge/Esposo(a)',
    'Padre',
    'Madre',
    'Hermano/Hermana',
    'Otro familiar'
  ];

  const handleAddMember = () => {
    if (newMember.name.trim() && newMember.age && newMember.relationship) {
      const member = {
        id: Date.now(),
        name: newMember.name.trim(),
        age: newMember.age,
        relationship: newMember.relationship
      };
      
      const updatedFamily = [...familyMembers, member];
      setFamilyMembers(updatedFamily);
      onFamilyChange(updatedFamily);
      
      // Reset form
      setNewMember({ name: '', age: '', relationship: '' });
      setShowAddForm(false);
    }
  };

  const handleRemoveMember = (id) => {
    const updatedFamily = familyMembers.filter(member => member.id !== id);
    setFamilyMembers(updatedFamily);
    onFamilyChange(updatedFamily);
  };

  const handleNoFamily = () => {
    setFamilyMembers([]);
    onFamilyChange([]);
    setShowAddForm(false);
  };

  return (
    <div className="family-members-container">
      <label className="family-members-label">Información de familiares:</label>
      
      {familyMembers.length > 0 && (
        <div className="family-members-list">
          {familyMembers.map((member) => (
            <div key={member.id} className="family-member-card">
              <div className="family-member-info">
                <span className="family-member-name">{member.name}</span>
                <span className="family-member-details">
                  {member.relationship} - {member.age} años
                </span>
              </div>
              <button 
                type="button"
                onClick={() => handleRemoveMember(member.id)}
                className="family-member-remove"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="family-members-actions">
        {!showAddForm ? (
          <div className="family-members-buttons">
            <button 
              type="button"
              onClick={() => setShowAddForm(true)}
              className="family-add-button"
            >
              + Agregar familiar
            </button>
            {familyMembers.length === 0 && (
              <button 
                type="button"
                onClick={handleNoFamily}
                className="family-no-family-button"
              >
                No tengo familiares
              </button>
            )}
          </div>
        ) : (
          <div className="family-add-form">
            <h4>Agregar familiar</h4>
            
            <div className="family-form-group">
              <label>Nombre completo:</label>
              <input
                type="text"
                value={newMember.name}
                onChange={(e) => setNewMember({...newMember, name: e.target.value})}
                placeholder="Ej. Juan Pérez"
              />
            </div>

            <div className="family-form-group">
              <label>Relación:</label>
              <select
                value={newMember.relationship}
                onChange={(e) => setNewMember({...newMember, relationship: e.target.value})}
              >
                <option value="">Selecciona la relación</option>
                {relationships.map(rel => (
                  <option key={rel} value={rel}>{rel}</option>
                ))}
              </select>
            </div>

            <div className="family-form-group">
              <label>Edad:</label>
              <input
                type="number"
                value={newMember.age}
                onChange={(e) => setNewMember({...newMember, age: e.target.value})}
                placeholder="Ej. 25"
                min="0"
                max="120"
              />
            </div>

            <div className="family-form-actions">
              <button 
                type="button"
                onClick={handleAddMember}
                className="family-save-button"
              >
                Agregar
              </button>
              <button 
                type="button"
                onClick={() => setShowAddForm(false)}
                className="family-cancel-button"
              >
                Cancelar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
